import type { ComponentType } from 'react';
import type { MarketingRouteKey } from './routes';

/**
 * One dynamic import per public page.
 *
 * The browser entry point resolves exactly the one the url needs and then
 * hydrates, so a visitor landing on /about never downloads the pricing page —
 * and, unlike React.lazy, nothing renders a Suspense fallback over prerendered
 * markup, which is what would make hydration throw the server html away.
 */
export const MARKETING_PAGE_LOADERS: Record<
  MarketingRouteKey,
  () => Promise<{ default: ComponentType }>
> = {
  home: () => import('../pages/LandingPage'),
  pricing: () => import('../pages/PricingPage'),
  about: () => import('../pages/marketing/AboutPage'),
  customers: () => import('../pages/marketing/CustomersPage'),
  careers: () => import('../pages/marketing/CareersPage'),
  blog: () => import('../pages/marketing/BlogPage'),
  blogPost: () => import('../pages/marketing/BlogPostPage'),
  press: () => import('../pages/marketing/PressPage'),
  contact: () => import('../pages/SalesContactPage'),
  notFound: () => import('../pages/marketing/NotFoundPage'),
};
